import React, { Fragment } from 'react'
import CommonEnrolmentFields from './common-fields'

const OaFields = (props) => (
  <Fragment>
    Made when another party (for example, an employer, other organisation,
    or the state - such as for participants in the Adult Migrant English Program)
    is liable for the fees for care of the child.
    <CommonEnrolmentFields
      {...props}
    />
  </Fragment>
)

export default OaFields



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/oa-fields.js